import React from 'react';
import { Modal } from '@gerdau/hefesto/';
import { ModalText } from './CartProductTable/style';

export const ValidationModal = ({
  show,
  title,
  description,
  handleNextBtn,
  handleNextBtnTitle,
  handleCloseValidationModal,
  loading,
  hiddenLeftButton
}: {
  hiddenLeftButton?: boolean;
  loading?: boolean;
  show: boolean;
  title: string;
  description: string;
  handleNextBtnTitle?: string;
  handleNextBtn: () => void;
  handleCloseValidationModal: () => void;
}) => {
  if (!show) {
    return null;
  }

  return (
    <Modal
      buttons={{
        ...(!hiddenLeftButton && {
          left: {
            children: 'Cancelar',
            name: 'cancel-delete',
            type: 'button',
            variant: 'secondary',
            onClick: handleCloseValidationModal,
            disabled: loading,
            loading
          }
        }),
        right: {
          children: handleNextBtnTitle ? handleNextBtnTitle : 'Alterar',
          name: 'detele',
          type: 'button',
          variant: 'primary',
          onClick: () => handleNextBtn(),
          disabled: loading,
          loading
        }
      }}
      modalSize="sm"
      title={title}
    >
      <ModalText>{description}</ModalText>
    </Modal>
  );
};
